/**
 * Enum for the different environments
 */
export enum PdEnv {
  DEVELOPMENT = 'development',
  STAGING = 'staging',
  PRODUCTION = 'production',
}
